import type { RestClient } from "./restClient";

export interface BillingPlan {
  id: string;
  name: string;
  description: string | null;
  price_monthly_cents: number;
  price_annual_cents: number;
  seat_limit: number | null;
  features: Record<string, unknown>;
}

export interface SubscriptionInfo {
  id: string;
  plan_id: string;
  billing_cycle: string;
  status: string;
  seat_limit: number | null;
  seats_used: number;
  current_period_end: string | null;
  sponsored: boolean;
}

export interface SubscribeResult {
  id: string;
  company_id: string;
  plan_id: string;
  billing_cycle: string;
  status: string;
  seat_limit: number | null;
  seats_used: number;
  current_period_end: string | null;
}

export class BillingApi {
  constructor(private client: RestClient) {}

  /** List active billing plans (public info, no Stripe price IDs). */
  plans(): Promise<BillingPlan[]> {
    return this.client.get("/v1/billing/plans");
  }

  /** Create a Stripe SetupIntent for collecting a payment method. */
  setupIntent(): Promise<{ client_secret: string }> {
    return this.client.post("/v1/billing/setup-intent");
  }

  /** Subscribe the company to a plan after payment method confirmation. */
  subscribe(params: {
    plan_id: string;
    billing_cycle: string;
    payment_method_id: string;
  }): Promise<SubscribeResult> {
    return this.client.post("/v1/billing/subscribe", params);
  }

  /** Get the current subscription for the company. */
  subscription(): Promise<{ subscription: SubscriptionInfo | null }> {
    return this.client.get("/v1/billing/subscription");
  }

  /** Create a Stripe Customer Portal session (returns redirect URL). */
  portal(returnUrl: string): Promise<{ url: string }> {
    return this.client.post("/v1/billing/portal", { return_url: returnUrl });
  }
}
